import {addLocaleData} from 'react-intl';

import localeData from '../lib/locale-data';
import editorMessages from '../lib/editor-messages';
import {isRtl} from '../lib/supported-locales';

addLocaleData(localeData);

const defaultProjectTitleOverride = {
    'gui.gui.defaultProjectTitle': 'Project'
};

const customEditorMessageOverrides = {
    en: {},
    ko: {
        'gui.sharedMessages.replaceProjectWarning': '현재 작업 내용이 사라질 수 있습니다. 계속할까요?',
        'gui.blockExportModal.title': '블록 이미지 내보내기',
        'gui.blockExportModal.description': '이미지 형식을 선택하세요. 기본값은 PNG입니다.',
        'gui.blockExportModal.formatLabel': '형식',
        'gui.blockExportModal.cancel': '취소',
        'gui.blockExportModal.export': '내보내기'
    }
};

const localizedEditorMessages = {
    ...editorMessages,
    en: {
        ...editorMessages.en,
        ...defaultProjectTitleOverride,
        ...customEditorMessageOverrides.en
    },
    ko: {
        ...editorMessages.ko,
        ...defaultProjectTitleOverride,
        ...customEditorMessageOverrides.ko
    }
};

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: localizedEditorMessages,
    messages: localizedEditorMessages.en
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: isRtl(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: action.messagesByLocale[state.locale]
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (Object.prototype.hasOwnProperty.call(currentState.messagesByLocale, locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
